module.exports = __webpack_public_path__ + "img/7.6444561a.jpg";